export default __webpack_public_path__ + "static/media/DNo.14-5.f7e35ca0.jpg";